import { QueryEffect } from '@helpers/QueryEffect';
import { useAlert } from '@hooks/useAlert';

import type { UseQueryHookResult } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import type { QueryDefinition } from '@reduxjs/toolkit/query';

export const EmployeeEffects = ({
    typeOfData,
    ...props
}: {
    queryState: UseQueryHookResult<QueryDefinition<any, any, any, any>>;
    typeOfData: string;
}) => {
    const { setAlert } = useAlert();

    return (
        <QueryEffect
            effects={{
                isError: () => setAlert(`Couldn't retrieve employee ${typeOfData}. Please reload.`, 'error'),
            }}
            {...props}
        />
    );
};
